import React from "react";

import { useSelector } from "react-redux";

import { AdminLink } from "components/AdminLink/AdminLink";
import AuditLogLink from "components/AuditLog/AuditLogLink";
import { Dialog, DialogTitle } from "components/MaterialDialog";
import { OverlayModalReadOnly } from "components/Modal";

import { AuditLogTypes } from "constants/auditLog";
import { ModalTypes } from "constants/navigation";
import { RuleBookPermission } from "constants/permissions";

import { hasPermission } from "lib/permissions";

import {
  getContextByModalType,
  getRuleBooks,
  getRuleById,
  selectRuleBookIdByRuleIdLookup,
} from "selectors";

import { EditCustomRuleForm } from "./CustomRule";
import { CustomiseManagedRuleModalForm } from "./ManagedRule";

export function RuleModal(props) {
  const { onClose } = props;

  const context = useSelector(getContextByModalType(ModalTypes.EditRule)) || {};
  const { ruleId = null, rule: templateRule = null } = context;

  const ruleBookByIdLookup = useSelector(getRuleBooks);
  const ruleBookIdByRuleIdLookup = useSelector(selectRuleBookIdByRuleIdLookup);
  const parentRuleBookId = ruleBookIdByRuleIdLookup[ruleId];
  const ruleBook = ruleBookByIdLookup[parentRuleBookId];

  const rule = useSelector(getRuleById(ruleId)) || null;

  const readOnly = !rule
    ? false
    : !hasPermission(ruleBook, RuleBookPermission.update);

  const mergedRule = {
    ...rule,
    ...templateRule,
  };

  const ruleBookId = mergedRule.rule_book_id || null;

  const isManagedRule = mergedRule.master_rule_id;

  if (!ruleBookId) {
    return null;
  }

  return (
    <Dialog open onClose={onClose} fullScreen>
      {readOnly && <OverlayModalReadOnly />}
      <DialogTitle onClose={onClose}>
        {ruleId && (
          <AuditLogLink
            auditLogType={AuditLogTypes.RULE}
            dataId={ruleId}
            returnTo={window.location.hash}
          />
        )}
        &nbsp;
        {ruleId ? (readOnly ? "View" : "Edit") : "Create"} Rule
        <AdminLink app="agrinous_rules" model="rule" cbid={ruleId} />
      </DialogTitle>
      {isManagedRule ? (
        <CustomiseManagedRuleModalForm
          ruleId={ruleId}
          ruleBookId={ruleBookId}
          onClose={onClose}
        />
      ) : (
        <EditCustomRuleForm onClose={onClose} ruleBookId={ruleBookId} />
      )}
    </Dialog>
  );
}
